import React, { useState, useContext } from "react";
import { Container, Row, Col, ProgressBar } from "react-bootstrap";
import AppContext from "../../../context";
import "../../page/page.scss";
import UploadPIFileForm from "./uploadPIFileForm";
import { postCsvFile } from "../../../services/http_operations";
import { csv_build_description_PI } from "../../../services/file_operations";
import { saveAs } from "file-saver";

const arraySepRef = React.createRef();
const floatSepRef = React.createRef();

export default function UploadPIPage() {
  const [csvContent, setCsvContent] = useState(null);
  const myLogs = useContext(AppContext).logs;
  const [now, setNow] = useState(0);
  const [files, setFiles] = useState(null);

  const [operationindex, setOperationIndex] = useState(0);
  //message for user
  const [msg, setMsg] = useState("");
  const [isError, setIsError] = useState(false);
  const [operationFailed, setOperationFailed] = useState(false);

  const [csvSep, setCsvSep] = useState(",");

  const postPI = async (e) => {
    e.preventDefault();
    const _csvSep = csvSep;
    const arraySep = arraySepRef.current.value;
    const floatSep = floatSepRef.current.value;
    setIsError(false);
    setOperationFailed(false);
    setMsg("");

    if (_csvSep === "" || arraySep === "" || floatSep === "") {
      setMsg("Please, define all the separators");
      setIsError(true);
      return;
    }
    if (_csvSep === arraySep || _csvSep === floatSep || arraySep === floatSep) {
      setMsg("All the separators should have different values");
      setIsError(true);
      return;
    }
    if (files === null || files === undefined || files.length === 0) {
      setMsg("Please, choose at least one file");
      setIsError(true);
      return;
    }
    setMsg("");
    setIsError(false);
    // begin loop on files

    setMsg("");
    setIsError(false);
    setNow(1);
    myLogs.PushLog({
      type: "info",
      msg: "-------Begin Upload Operation " + operationindex + "-------\n",
    });

    const failedFiles = [];
    const hashValues = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Check if the file ends with #merged.csv
      if (file.name.endsWith("#merged.csv")) {
        myLogs.PushLog({
          type: "info",
          msg: "Skipped merged file " + file.name + "\n",
        });
        continue;  // Skip this file and move to the next
      }
      
      myLogs.PushLog({
        type: "info",
        msg: "Uploading file " + file.name + "\n",
      });
      const desc = await csv_build_description_PI(file);   
      // Check if the URL contains 'pi-test'
      if (!window.location.href.includes('pi-test')) {
        desc.visibility= "public"; // set default visibility to public
        console.log("Setting visibility to public for file: " + file.name);
      }
      console.log(desc);
      
      if (desc.warnings !== undefined) {
        desc.warnings.forEach((warning) => {
          myLogs.PushLog({
            type: "warning",
            msg: "Warning: " + warning,
          });
        });

        delete desc.warnings;
      }
      if (desc.errors !== undefined) {
        desc.errors.forEach((error) => {
          myLogs.PushLog({
            type: "error",
            msg: "Error: " + error,
          });
        });
        failedFiles.push(file.name);
        setMsg("Error uploading: " + failedFiles.join(", "));
        setIsError(true);
        setOperationFailed(true);
        continue;
      }
      try {
        const response = await postCsvFile(
          file,
          desc,
          _csvSep,
          arraySep,
          floatSep
        );
        if (response.status !== 200) {
          response.data.errors.forEach((error) => {
            myLogs.PushLog({
              type: "error",
              msg: "Error: " + error + "\n",
            });
          });
        }
      } catch (error) {
        console.error(error);
        setOperationFailed(true);
      }
      hashValues.push({fileName:file.name, hash:desc.thing});
      setNow((100 * (i + 1)) / files.length);
    }

    myLogs.PushLog({
      type: "info",
      msg: "-------End Upload Operation " + operationindex + "-------\n\n",
    });
    // save file hashes
    const fileHashes = JSON.stringify(hashValues, null, 4);
    saveAs(new Blob([fileHashes], { type: "application/json" }), "file_ids.json");
    setOperationIndex((prev) => prev + 1);
    setNow(100);
  };

  return (
    <div className="page">
      <header className="page-header">Upload PIs</header>
      <main className="page-content">
        <Container fluid>
          <Row>
            <UploadPIFileForm
              postPI={postPI}
              arraySepRef={arraySepRef}
              csvSep={csvSep}
              setCsvSep={setCsvSep}
              floatSepRef={floatSepRef}
              setCsvContent={setCsvContent}
              setFiles={setFiles}
              files={files}
              csvContent={csvContent}
            />
          </Row>

          <Row>
            <Col>
              <font
                style={{
                  marginLeft: 5 + "px",
                  color: isError ? "red" : "black",
                }}
              >
                {msg}
              </font>
            </Col>
          </Row>
          <Row style={{ paddingTop: 10 + "px", paddingBottom: 10 + "px" }}>
            <Col>
              <ProgressBar
                now={now}
                label={`${now}%`}
                variant={
                  operationFailed === true
                    ? "danger"
                    : now === 100
                    ? "success"
                    : "info"
                }
              />
            </Col>
          </Row>
          <Row style={{ paddingTop: 10 + "px", paddingBottom: 10 + "px" }}>
            <Col>
              <b>Operation logs</b>
            </Col>
          </Row>
          <Row>
            <Col>
              <textarea
                id="logger"
                style={{ resize: "both", width: 30 + "vw", height: 30 + "vh" }}
                //cols="100"
                //rows="10"
                readOnly
                value={myLogs.logs
                  .map((l) => l.msg)
                  .reverse()
                  .join("-")}
              />
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}
